import { TbChevronDown } from 'react-icons/tb'
import { ChangeEvent } from 'react'
import { Text } from 'ui-kit/typography'
import {
  getReadableScenariosTagName,
  isActiveScenariosTag,
} from 'routes/Scenarios/helpers'
import { ScenarioTagsProps } from 'routes/Scenarios/helpers/types'
import clsx from 'clsx'
import classes from './ScenariosTags.module.scss'

export const ScenariosTags = ({ ...props }: ScenarioTagsProps) => {
  return (
    <>
      <TagsSelect {...props} />
      <TagsGrid {...props} />
    </>
  )
}

const TagsGrid = ({ tags, value, onChange }: ScenarioTagsProps) => {
  return (
    <ul className={classes.list}>
      {tags.map(({ tag, count }, idx) => (
        <li
          key={idx}
          className={clsx(
            classes.item,
            isActiveScenariosTag(tag, value) && classes.item__active,
          )}
          onClick={() => {
            onChange(tag)
          }}
        >
          {getReadableScenariosTagName(tag)}
          <Text as={'span'} className={classes.amount}>
            {count}
          </Text>
        </li>
      ))}
    </ul>
  )
}

const TagsSelect = ({ tags, value, onChange }: ScenarioTagsProps) => {
  function handleSelectChange(e: ChangeEvent<HTMLSelectElement>) {
    onChange(e.target.value)
  }

  return (
    <div className={classes.select}>
      <select
        aria-label='select scenarios tag'
        value={value}
        className={classes.dropdown}
        onChange={handleSelectChange}
      >
        {tags.map(({ tag, count }, idx) => (
          <option value={tag || ''} key={idx}>
            {`${getReadableScenariosTagName(tag)} (${count})`}
          </option>
        ))}
      </select>
      <TbChevronDown className={classes.icon} />
    </div>
  )
}
